var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4717 7.72152C7.17633 8.01689 7.17633 8.49576 7.4717 8.79113L10.6805 11.9999L7.47152 15.2089C7.17616 15.5042 7.17616 15.9831 7.47152 16.2785C7.76689 16.5738 8.24576 16.5738 8.54113 16.2785L11.7501 13.0695L14.9589 16.2784C15.2543 16.5737 15.7332 16.5737 16.0285 16.2784C16.3239 15.983 16.3239 15.5041 16.0285 15.2088L12.8197 11.9999L16.0284 8.79124C16.3237 8.49588 16.3237 8.017 16.0284 7.72164C15.733 7.42627 15.2541 7.42627 14.9588 7.72164L11.7501 10.9303L8.5413 7.72152C8.24594 7.42616 7.76706 7.42616 7.4717 7.72152Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesSmall);
export default __webpack_public_path__ + "static/media/times_small.41d8c6f1ea5367f020751e681137df4a.svg";
export { ForwardRef as ReactComponent };